// (C) Copyright 2025 Hewlett Packard Enterprise Development LP

import React from 'react'
import { useTranslation } from 'react-i18next'
import { GenieChatPanel } from '@glcp/genie-ui'
import { useReactOidc } from '@axa-fr/react-oidc-context'

import { useCCSContext } from './context/ccs-context'

const Genie = () => {
  const { i18n } = useTranslation()
  const { csrfToken } = useCCSContext()
  const { oidcUser } = useReactOidc()

  return (
    <GenieChatPanel
      locale={i18n.language}
      baseURL={`${window?.$settings.orgBaseUrl}`}
      oidcUser={oidcUser}
      csrfToken={csrfToken}
    />
  )
}

export default Genie
